import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RulesComponent} from './rules.component';
import {FormsModule} from '@angular/forms';
import {MaterialModule} from '../../material.module';
import {InfraModule} from 'ac-infra';
import {RoutingRulesDialogModule} from './routing-rules-dialog/routing-rules-dialog.module';
import {LayoutModule} from '../../components/layout/layout.module';
import {SearchModule} from '../../components/search/search.module';
import {ActionBarModule} from '../../components/action-bar/action-bar.module';
import {ArmTableModule} from '../../components/arm-table/arm-table.module';
import {MoveRuleDialogComponent} from './move-rule-dialog/move-rule-dialog.component';
import {DialogsModule} from '../../dialogs/dialogs.module';
import {RoutingRuleStateTablePipe} from '../pipes/routing-rule-state-pipe';

@NgModule({
  declarations: [
    RulesComponent,
    MoveRuleDialogComponent,
    RoutingRuleStateTablePipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    InfraModule,
    RoutingRulesDialogModule,
    LayoutModule,
    SearchModule,
    ActionBarModule,
    ArmTableModule,
    DialogsModule
  ]
})
export class RulesModule { }
